import { useT } from '../../hooks/useT';
import styles from './TextBlock.module.css';

function TextBlock({ contentKey, align = 'left' }) {
  const t = useT();
  const raw = t(contentKey) || '';

  // Support newlines and basic bullet points (lines starting with - or •)
  const lines = raw.split('\n');
  const hasBullets = lines.some((l) => /^\s*[-•]\s/.test(l));

  if (hasBullets) {
    // Tag each line as 'bullet' or 'text'
    const tagged = lines.map((line) => {
      if (/^\s*[-•]\s/.test(line)) {
        return { type: 'bullet', text: line.replace(/^\s*[-•]\s*/, '') };
      }
      return { type: 'text', text: line };
    });

    // Group consecutive bullets into lists, rest as paragraphs
    const groups = [];
    let currentGroup = null;

    tagged.forEach((item) => {
      if (item.type === 'bullet') {
        if (!currentGroup || currentGroup.type !== 'bullets') {
          currentGroup = { type: 'bullets', items: [] };
          groups.push(currentGroup);
        }
        currentGroup.items.push(item.text);
      } else {
        if (!currentGroup || currentGroup.type !== 'text') {
          currentGroup = { type: 'text', lines: [] };
          groups.push(currentGroup);
        }
        currentGroup.lines.push(item.text);
      }
    });

    return (
      <div className={styles.wrapper} style={{ textAlign: align }}>
        {groups.map((group, i) => {
          if (group.type === 'bullets') {
            return (
              <ul key={i} className={styles.list}>
                {group.items.map((text, j) => (
                  <li key={j} className={styles.listItem}>{text}</li>
                ))}
              </ul>
            );
          }
          const content = group.lines.join('\n').trim();
          if (!content) return null;
          return (
            <p key={i} className={styles.text} style={{ textAlign: align, whiteSpace: 'pre-line' }}>
              {content}
            </p>
          );
        })}
      </div>
    );
  }

  // Plain text with newline support
  return (
    <p className={styles.text} style={{ textAlign: align, whiteSpace: 'pre-line' }}>
      {raw}
    </p>
  );
}

export default TextBlock;
